import React, { useState } from 'react';
import { LocalizationContext } from 'contexts/Localization';
import {
  BoxBaseStyled,
  ColCentered,
  ColStyled,
  ImageWrapper,
  DynamicImageStyled,
  VideoWrapper,
  IframeStyled,
  ExitArea,
  ButtonWrapper,
} from './styles'
import ButtonCircle from 'components/ButtonCircle';
import Modal from 'components/Modal';
import { H4, Text } from 'styles/components/typography';
import { em } from 'polished';
import PropTypes from 'prop-types';

const BAboutDemo = ({ texts }) => {
  const { paths } = React.useContext(LocalizationContext);
  const [isOpened, setOpened] = useState(false);
  const toggleModal = (newState) => setOpened(newState);
  return (
    <>
      <BoxBaseStyled>
        <ColStyled>
          <ImageWrapper onClick={() => toggleModal(true)}>
            <DynamicImageStyled
              image={`${paths.cdn_global}/boxes/biome-about-demo-guide`}
              imageSizes={{ xs: 320, md: 500 }}
              imageType="png"
              fitOption={'contain'}
              alt={'Microbiome Box'}
            />
            <ButtonWrapper>
              <ButtonCircle
                size="large"
                as="button"
                bgClassName="bg--white"
                blackoutClassName="bg--white"
                textClassName="text"
                icon="btn_play"
                iconColor="black"
              />
            </ButtonWrapper>
          </ImageWrapper>
        </ColStyled>
        <ColCentered >
          <H4
            dangerouslySetInnerHTML={{ __html: texts.title }}
          />
          <Text
            dangerouslySetInnerHTML={{ __html: texts.body }}
            pt={{ xs: em(2), md: em(4) }}
          />
        </ColCentered>
      </BoxBaseStyled>
      <Modal
        modalOpen={isOpened}
        isMobile={true}
        handleCloseModal={() => toggleModal(false)}
      >

        <VideoWrapper>
          <ExitArea onClick={() => toggleModal(false)}/>
          <IframeStyled
            src="https://www.youtube.com/embed/M2XENELMNLY"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </VideoWrapper>
      </Modal>
    </>
  )
}

BAboutDemo.propTypes = {
  texts: PropTypes.object.isRequired,
}

BAboutDemo.defaultProps = {}

export default BAboutDemo;
